export const PartnerProgramStatisticBlock = ({className, img, description}) => {
  return(
      <div className={`partner_program_statistic_block ${"partner_program_statistic_block" + className}`}>
          <img src={img} alt=""/>
          <p className="partner_program_statistic_block_text">
              {description}
          </p>
      </div>
  )
}